var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("h3", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("apeironGwApp.datosBeca.title"))),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.nombre"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.becario?.nombre +
                                  " " +
                                  _vm.form.beca?.becario?.apellidoPaterno +
                                  " " +
                                  _vm.form.beca?.becario?.apellidoMaterno
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t("apeironGwApp.datosBeca.label.curp"),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.solicitud?.solicitante?.curp)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.convocatoria"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.solucionSolicitud
                                  ?.nombreConvocatoria
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t("apeironGwApp.datosBeca.label.grado"),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.form.beca?.programa?.grado)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.clavePrograma"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.form.beca?.programa?.clave)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.nombrePrograma"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.form.beca?.programa?.nombre)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.institucion"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.programa?.institucion
                                  ?.nombreInstitucion
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.caracteristica"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.form.beca?.programa?.caracteristica)
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t("apeironGwApp.datosBeca.label.sede"),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.programa?.sede?.nombreDependencia
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.ubicacionSede"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.beca?.programa?.sede?.descripcionSede
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.nacionalidad"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.solicitud?.solicitante?.nacionalidad)
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "lg",
                            label: _vm.$t(
                              "apeironGwApp.datosBeca.label.estatusBeca"
                            ),
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.form.beca?.estadoActual)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-container"),
        ],
        1
      ),
      _vm._v(" "),
      _vm.solicitud.solicitudUri
        ? _c(
            "b-link",
            { attrs: { href: _vm.solicitud.solicitudUri, target: "_blank" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", id: "id-convenio" },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.datosBeca.label.solicitud")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "icon-descargar" }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSaving()
        ? _c(
            "b-button",
            {
              attrs: { variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save(_vm.form)
                },
              },
            },
            [
              _c("span", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("apeironGwApp.datosBeca.acciones.confirmarDatosBeca")
                  ),
                },
              }),
              _vm._v(" "),
              _c("b-icon", { attrs: { icon: "save" } }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }